import { render, staticRenderFns } from "./JaTermsOfUse.vue?vue&type=template&id=c200edea&scoped=true"
import script from "./JaTermsOfUse.vue?vue&type=script&lang=js"
export * from "./JaTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c200edea",
  null
  ,true
)

export default component.exports